<template>
    <div class="cards-container">
        <div class="filter-section">
            <slot></slot>
        </div>
        <div class="row w-100" v-if="cardType === 'community'">
            <div
                v-if="!cards || !cards.length"
                class="no-cards w-100"
            >
            <code-message>
                There are no communities to show. <a target="_blank" href="//community.codemotion.com">Join</a> or <router-link to="create-community">create one!</router-link>
            </code-message>
            
            </div>
            <Card v-else v-for="(card, index) in cards" :key="index" :management="management">
                <a v-if="!management" :href="'//community.codemotion.com/'+card.slug">
                    <community-card :card="card" />
                </a>
                <community-card
                    v-else-if="cardType==='community'"
                    :management="management"
                    :card="card"
                />
            </Card>
        </div>
        <div class="row w-100" v-else-if="cardType === 'challenge'">
            <div v-if="!cards || !cards.length" class="no-cards w-100">
                <code-message>
                    There are no coding challenges to show.
                <a
                    class="ml-2"
                    href="//events.codemotion.com/coding-challenges"
                >Try one!</a>
                </code-message>
                
            </div>
            <Card v-else v-for="(card, index) in cards" :key="index">
                <a :href="'//events.codemotion.com/coding-challenges/'+card.slug">
                    <challenge-card :card="card" />
                </a>
            </Card>
        </div>
        <div class="row w-100" v-else-if="cardType === 'hackathon'">
            <div v-if="!cards || !cards.length" class="no-cards w-100">
                <code-message>
                    You did not register to any Online Hackathon
                <a
                    class="ml-2"
                    href="//events.codemotion.com/hackathons"
                >Enroll now!</a>
                </code-message>
                
            </div>
            <Card v-else v-for="(card, index) in cards" :key="index">
                <a :href="card.full_url">
                    <hackathon-card :card="card" />
                </a>
            </Card>
        </div>
    </div>
</template>

<script>
import Card from "./Card.vue";
import CommunityCard from "./Cards/CommunityCard.vue";
import ChallengeCard from "./Cards/ChallengeCard.vue";
import HackathonCard from "./Cards/HackathonCard.vue";
import CodeMessage from "@/components/CodeMessage.vue";

export default {
    name: "Cards",
    components: {
        Card,
        CommunityCard,
        ChallengeCard,
        HackathonCard,
        CodeMessage
    },
    props: ["cardType", "cards", "management"]
};
</script>

<style lang="scss">
@import "@/assets/scss/_common.scss";
.cards-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    position: relative;
    max-width: 1440px;
    margin: auto;
}
div.no-cards {
    height: 100%;
    text-align: left;
    display: flex;
    font-size: 1.3rem;
    color: lightgray;
    line-height: 1.5;
    margin: 15px;
}
</style>
